import { HiOutlineTrash } from "react-icons/hi";

const DeleteCourseButton = () => {
    return <HiOutlineTrash style={{ color: "red" }} />
}
export default DeleteCourseButton